import * as __au2ViewDef from './ia-modal.html';
import { bindable, customElement, INode } from 'aurelia';

@customElement({ ...__au2ViewDef, name: 'ia-modal' })
export class IaModal {
    @bindable showing = false;

    @bindable callback: any = closeModal;

    @bindable confirmButtonState = false;
    @bindable showCloseButton = true;

    @bindable keyClose = true;
    @bindable clickClose = true;

    @bindable viewModel;
    @bindable viewContent;

    @bindable type = 'confirm';

    @bindable isModalProcessing = false;

    private confirmButtonText;

    constructor(@INode readonly element: INode) {}

    bound() {
        this.isModalProcessingChanged(false);
    }

    attached() {
        if (this.clickClose && this.type !== 'confirm') {
            document.addEventListener('click', (e: any) => {
                if (
                    e.target &&
                    e.target.classList &&
                    e.target.classList.contains('modal') &&
                    this.showing
                ) {
                    this.showing = false;

                    if (this.callback) {
                        this.callback({ type: 'clickClosed' });
                    }
                }
            });
        }

        if (this.keyClose && this.type !== 'confirm') {
            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 27 && this.showing) {
                    this.showing = false;

                    if (this.callback) {
                        this.callback({ type: 'keyClosed' });
                    }
                }
            });
        }
    }

    confirmAgreeCallback() {
        this.callback({ type: 'confirm' });
        //this.showing = false;
    }

    confirmCancelCallback() {
        this.callback({ type: 'cancel' });
        this.showing = false;
    }

    isModalProcessingChanged(newVal) {
        if (newVal) {
            this.confirmButtonText = 'processing...';
        } else if (!newVal) {
            this.confirmButtonText = 'Confirm & Proceed';
        }
    }
}

export function closeModal() {
    return false;
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = IaModal;

    // @ts-ignore
    const proto = IaModal.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }